import { keepPreviousData } from "@tanstack/react-query";
import { useAssetListQueryState } from "../../utils/useAssetListQueryState";
import { useMemo } from "react";
import { trpc } from "../trpc";
import { ListChatbotsInput } from "@zapier/bff";

export function useQueryChatbots(parameters: ListChatbotsInput) {
  const query = trpc.chatbot.list.useQuery(parameters, {
    placeholderData: keepPreviousData,
  });
  const { isLoading, isFetching } = query;
  const { data, loadError } = useAssetListQueryState(query);

  const chatbots = useMemo(() => data?.data, [data]);
  const meta = useMemo(() => data?.meta, [data]);

  return {
    loadError,
    chatbots,
    isLoading,
    isFetching,
    meta,
  };
}

export type Chatbot = NonNullable<
  ReturnType<typeof useQueryChatbots>["chatbots"]
>[number];
